import { Component } from "react";

import { Button, Box } from "@mui/material";
import { withStyles } from "@mui/styles";
import PropTypes from "prop-types";
import { injectIntl, FormattedMessage } from "react-intl";

import PasswordField from "../../signup/components/PasswordField/PasswordField";

class NewPasswordForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: "",
      passwordLengthError: false,
    };
  }

  onInputChange = (e) => {
    const name = e.target.name;
    this.setState({
      [name]: e.target.value,
    });
  };

  onInputFocus = () => {
    this.setState({
      passwordLengthError: false,
    });
  };

  validateLength = (callback) => {
    const password = this.state.password;
    if (password.trim().length < 6) {
      this.setState({
        passwordLengthError: true,
      });
      return;
    }
    this.setState(
      {
        passwordLengthError: false,
      },
      callback,
    );
  };

  submit = () => {
    this.validateLength(() => {
      if (!this.state.passwordLengthError) {
        this.props.onNewPassword(this.state.password);
      }
    });
  };

  render() {
    const { classes } = this.props;
    const { formatMessage } = this.props.intl;
    const { password, passwordLengthError } = this.state;

    return (
      <Box display="flex" flexDirection="column" gap={2}>
        <h3 className={classes.header}>
          <FormattedMessage id="reset.password.header" />
        </h3>
        <FormattedMessage id="reset.password.guide" />
        <PasswordField
          fullWidth={true}
          hintText={formatMessage({ id: "reset.password.hint" })}
          label={<FormattedMessage id="reset.password.label" />}
          onBlur={() => this.validateLength()}
          onChange={(e) => this.onInputChange(e)}
          onFocus={(e) => this.onInputFocus(e)}
          value={password}
          errorText={
            passwordLengthError && (
              <FormattedMessage id="reset.password.length.error" />
            )
          }
        />
        <Button
          className={classes.button}
          color="primary"
          id="new-password"
          onClick={() => this.submit()}
          variant="contained"
        >
          <FormattedMessage id="reset.password.button" />
        </Button>
      </Box>
    );
  }
}

NewPasswordForm.propTypes = {
  classes: PropTypes.object.isRequired,
  onNewPassword: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

const style = {
  textField: {
    textAlign: "left",
    width: "100%",
    marginTop: 0,
  },
  header: {
    marginTop: 0,
    fontWeight: 500,
    fontSize: 24,
  },
  button: {
    width: "100%",
  },
};

export default injectIntl(withStyles(style)(NewPasswordForm));
